<div style="justify-content: center; display: flex">
  @if (events?.length == 0) {
    <div>N/A</div>
  }
  @for (item of events; track item) {
    <button
      id="event"
      style="
        border: 0.45px;
        border-color: transparent;
        background-color: transparent;
      "
      disabled
    >
      <img
        alt="event icon"
        src="assets/images/icons/{{ setStatusIcon(item.id || item) }}.png"
        title="{{ item.name || getEventTitle(item.id || item) }}"
      />
    </button>
  }
</div>
